export default "__VITE_ASSET__BDYfow6p__"